import { useState } from "react";
import { OverlayModal } from "./components/OverlayModal";
import { MainSection } from "./sections/MainSection";

function App() {
  // null = undetermined (waiting for API), false = show branding, true = hide branding
  const [isWhiteLabel, setIsWhiteLabel] = useState<boolean | null>(null);

  return (
    <OverlayModal isWhiteLabel={isWhiteLabel}>
      <MainSection setIsWhiteLabel={setIsWhiteLabel} isWhiteLabel={isWhiteLabel} />
    </OverlayModal>
  );
}

export default App;
